import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";

import { useSidebar } from "~/contexts/Sidebar";
import { ToastMessageMeta } from "~/tools/js/Shared/stores/typings";

import { toastMessageActions } from "../../../../../../tools/js/Shared/actions";

interface Props {
  errorTitle?: string;
  errorMessage?: string;
  toastMeta?: ToastMessageMeta;
}
export const PaneInitFailureContent: FC<Props> = ({
  errorTitle,
  errorMessage,
  toastMeta,
}) => {
  const dispatch = useDispatch();
  const {
    sidebar: { setIsVisible },
    pane: { resetActivePane },
  } = useSidebar();

  useEffect(() => {
    resetActivePane();
    setIsVisible(false);
    dispatch(
      toastMessageActions.toastError(
        errorTitle ?? "Content Error",
        errorMessage ?? "We couldn't find that content! Please try again.",
        toastMeta
      )
    );
  }, [errorMessage, errorTitle, toastMeta]);

  return null;
};
